import { AXIOS_INSTANCE } from '@/shared/api/mutator/custom-instance';

const API_BASE = '/api/essence/day-end';

export interface DayEndResult {
    success: boolean;
    stepsCompleted: string[];
    error: string | null;
    currentSessionDate?: string | null;
    nextSessionDate?: string | null;
    sessionStatus?: string | null;
}

export interface BranchSessionSummary {
    branch: string;
    branchName: string;
    branchFullName: string;
    sessionDate: string;
    sessionStatus: string;
}

export interface CompanySessionSummary {
    currentSessionDate: string | null;
    nextSessionDate: string | null;
    sessionStatus: string | null;
    referenceBranch: string | null;
    branches: BranchSessionSummary[];
}

export interface DayProcessProgressEvent {
    operation: string;
    message: string;
    status: string;
    branch: string | null;
    performedBy: string;
    completedBranches: number | null;
    totalBranches: number | null;
    cycle: number | null;
    totalCycles: number | null;
    currentSessionDate: string | null;
    targetDate: string | null;
    completed: boolean;
    success: boolean;
    forceLogout: boolean;
}

export interface DayEndRun {
    id: number;
    branch: string;
    sessionDate: string;
    runType: 'SOD' | 'EOD';
    status: 'RUNNING' | 'DONE' | 'FAILED';
    startedBy: string;
    startedAt: string;
    completedAt: string | null;
    errorMessage: string | null;
}

export const DayEndService = {
    runSod: (branch: string, targetDate?: string | null): Promise<DayEndResult> =>
        AXIOS_INSTANCE.post<DayEndResult>(`${API_BASE}/${branch}/sod`, targetDate ? { targetDate } : {}).then(r => r.data),

    runEod: (branch: string): Promise<DayEndResult> =>
        AXIOS_INSTANCE.post<DayEndResult>(`${API_BASE}/${branch}/eod`).then(r => r.data),

    getSummary: (branch: string): Promise<CompanySessionSummary> =>
        AXIOS_INSTANCE.get<CompanySessionSummary>(`${API_BASE}/${branch}/summary`).then(r => r.data),

    getHistory: (branch: string): Promise<DayEndRun[]> =>
        AXIOS_INSTANCE.get<DayEndRun[]>(`${API_BASE}/${branch}/history`).then(r => r.data),

    getStatusForDate: (branch: string, date: string): Promise<DayEndRun | null> =>
        AXIOS_INSTANCE.get<DayEndRun>(`${API_BASE}/${branch}/status/${date}`)
            .then(r => r.data)
            .catch(err => {
                if (err.response?.status === 404) return null;
                throw err;
            }),

    getCurrentRunning: (branch: string): Promise<DayProcessProgressEvent | null> =>
        AXIOS_INSTANCE.get<DayProcessProgressEvent>(`${API_BASE}/${branch}/current-running`)
            .then(r => r.data)
            .catch(err => {
                if (err.response?.status === 404) return null;
                throw err;
            }),
};
